export default __webpack_public_path__ + "media/images/fancybox/fancy_loading-7f46a281e298454ab451ad09303efee5.png";